import * as React from "react"
import { PropsWithoutRef } from "react"

import { Brand, BrandLogo } from "./styles"

export interface BrandData {
  publicURL: string;
  name: string;
}

export default function BrandComponent(props: PropsWithoutRef<{ root?: string; brand: BrandData, className?: string, animate?: any}>) {
  return (
    <Brand to={props.root || "/"} disabled={!props.root} className={props.className}>
      <BrandLogo {...props.animate} src={props.brand.publicURL} alt={props.brand.name}/>
    </Brand>
  )
}
